<template>
  <div>
    <b-row>
      <!-- about  -->
      <b-col lg="4" md="6" cols="12" class="pt-2">
        <b-card
          :disabled="!hasInterview || loading"
          :class="{
            'disabled-card': !hasInterview || loading,
            clickable: hasInterview,
          }"
          class="p-1 clickable tool-card"
          @click.prevent="
            hasInterview ? getCustomerFinancialDiagnosisToken() : null
          "
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="SearchIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75 text-center">Diagnóstico financeiro</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">
              {{
                loading
                  ? "Aguarde..."
                  : hasInterview
                  ? "Acesse o diagnóstico financeiro do seu cliente aqui!"
                  : "O diagnóstico financeiro ficará disponível após envio da pré-entrevista."
              }}
            </span>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>

      <!-- Pré-Entrevista por IA -->
      <b-col
        lg="4"
        md="6"
        cols="12"
        class="pt-2"
        v-if="canSendAiPreInterview || canReadAiPreInterview"
      >
        <b-card
          :disabled="aiLoading"
          :class="{ 'disabled-card': aiLoading }"
          class="p-1 clickable tool-card"
          @click.prevent="onAiCardClick"
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="CpuIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75 text-center">Pré-Entrevista por IA</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">
              {{ aiLoading ? "Aguarde..." : aiCardSubtitle }}
            </span>
          </b-row>
          <b-row
            class="justify-content-center mt-1"
            v-if="aiStatus && aiStatus.status !== 'nao_enviada'"
          >
            <b-badge :variant="aiStatusData.variant">{{
              aiStatusData.label
            }}</b-badge>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>

      <b-col lg="4" md="6" cols="12" class="pt-2">
        <b-card
          v-if="canReadMomentX"
          :disabled="!hasInterview || loading"
          :class="{
            'disabled-card': !hasInterview || loading,
            clickable: hasInterview,
          }"
          class="p-1 clickable tool-card"
          @click.prevent="hasInterview ? goToFinancialPlanning() : null"
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="DollarSignIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75 text-center">Momento X</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">
              {{
                loading
                  ? "Aguarde..."
                  : hasInterview
                  ? "Acesse o Momento X e plano financeiro do seu cliente aqui!"
                  : "O Momento X e plano financeiro ficarão disponíveis após envio da pré-entrevista."
              }}
            </span>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>
      <b-col
        lg="4"
        md="6"
        cols="12"
        class="pt-2"
        v-if="customerType === profileType.PROFILE_TYPE_CUSTOMER"
      >
        <b-card
          v-if="canReadApp"
          :disabled="loading"
          class="p-1 clickable tool-card"
          @click.prevent="getCustomerCashFlowToken"
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="SettingsIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75">Meu Futuro App</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">{{
              loading
                ? "Aguarde..."
                : "Acesse as ferramentas financeiras do seu cliente aqui!"
            }}</span>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" md="6" cols="12" class="pt-2" v-if="canUpdateCustomer">
        <b-card
          :disabled="!canReopenPreInterview || loading"
          :class="{
            'disabled-card': !canReopenPreInterview || loading,
            clickable: canReopenPreInterview,
          }"
          class="p-1 clickable tool-card"
          @click.prevent="canReopenPreInterview ? reopenPreInterview() : null"
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="RefreshCwIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75 text-center">Reabrir pré-entrevista</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">
              {{
                loading
                  ? "Aguarde..."
                  : hasFinishedPreInterview
                  ? "Reabra a pré-entrevista para o cliente preencher novamente. Os dados já informados são preservados."
                  : aiConcluded
                  ? "Reabra a Pré-Entrevista por IA para o cliente preencher novamente. Os resultados recebidos são preservados."
                  : "Disponível apenas após o cliente finalizar a pré-entrevista."
              }}
            </span>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>

      <!-- Código de Acesso Meu Futuro -->
      <b-col lg="4" md="6" cols="12" class="pt-2" v-if="canReadApp && !customer.meufuturo_user_id">
        <b-card
          :disabled="plannerCodeLoading"
          :class="{ 'disabled-card': plannerCodeLoading }"
          class="p-1 clickable tool-card"
          @click.prevent="openPlannerCodeModal"
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="KeyIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75 text-center">Código de Acesso</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">
              {{ plannerCodeLoading ? "Aguarde..." : "Gere um código para o cliente se cadastrar no Meu Futuro App vinculado à sua consultoria." }}
            </span>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>

      <!-- Tarefas Meufuturo App -->
      <b-col
        lg="4"
        md="6"
        cols="12"
        class="pt-2"
        v-if="canManagePlanImplementation && !!customer.meufuturo_user_id"
      >
        <b-card
          class="p-1 clickable tool-card"
          @click.prevent="goToPlanImplementation"
        >
          <b-row class="justify-content-center">
            <div class="rounded-icon">
              <feather-icon icon="CheckSquareIcon" size="28" class="text-info" />
            </div>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h4 class="mb-75 text-center">Tarefas Meufuturo App</h4>
          </b-row>
          <b-row class="justify-content-center">
            <span class="text-center">
              Gerencie tarefas, marcos e objetivos secundários do plano do cliente no app.
            </span>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <div class="border-line"></div>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Código de Acesso Meu Futuro -->
    <b-modal
      id="planner-code-modal"
      title="Código de Acesso — Meu Futuro App"
      hide-footer
      centered
    >
      <template v-if="!generatedPlannerCode">
        <p class="mb-1">
          Gere um código exclusivo de 6 caracteres para que
          <strong>{{ customer.name }}</strong> se cadastre no Meu Futuro App
          vinculado à sua consultoria.
        </p>
        <p class="text-muted small mb-2">
          O código ficará ativo por 90 dias e pode ser usado uma única vez.
        </p>
        <b-button
          variant="primary"
          block
          :disabled="plannerCodeLoading"
          @click="handleGeneratePlannerCode"
        >
          <feather-icon icon="KeyIcon" class="mr-50" />
          {{ plannerCodeLoading ? "Gerando..." : "Gerar código" }}
        </b-button>
      </template>

      <template v-else>
        <p class="mb-1">
          Compartilhe este código com <strong>{{ customer.name }}</strong>:
        </p>
        <div class="planner-code-display mb-2">
          <span class="planner-code-value">{{ generatedPlannerCode }}</span>
        </div>
        <div class="d-flex flex-column">
          <b-button
            variant="outline-primary"
            class="mb-1"
            @click="copyPlannerCode"
          >
            <feather-icon icon="CopyIcon" class="mr-50" /> Copiar código
          </b-button>
          <b-button
            variant="outline-success"
            class="mb-1"
            :disabled="!customer.cell_phone"
            @click="sharePlannerCodeWhatsApp"
          >
            <feather-icon icon="MessageCircleIcon" class="mr-50" />
            Enviar por WhatsApp
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="handleGeneratePlannerCode"
            :disabled="plannerCodeLoading"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            {{ plannerCodeLoading ? "Gerando..." : "Gerar novo código" }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Pré-Entrevista por IA — ações de envio -->
    <b-modal
      id="ai-pre-interview-modal"
      title="Pré-Entrevista por IA"
      hide-footer
      centered
    >
      <p class="mb-1">
        Gere e envie o link individual da Pré-Entrevista por IA para o cliente:
      </p>
      <div class="d-flex flex-column">
        <b-button
          variant="outline-primary"
          class="mb-1"
          :disabled="aiLoading"
          @click="sendAiByChannel('link', 'open')"
        >
          <feather-icon icon="ExternalLinkIcon" class="mr-50" /> Abrir em nova aba
        </b-button>
        <b-button
          variant="outline-primary"
          class="mb-1"
          :disabled="aiLoading"
          @click="sendAiByChannel('link', 'copy')"
        >
          <feather-icon icon="CopyIcon" class="mr-50" /> Copiar link
        </b-button>
        <b-button
          variant="outline-primary"
          class="mb-1"
          :disabled="aiLoading"
          @click="sendAiByChannel('email', 'email')"
        >
          <feather-icon icon="MailIcon" class="mr-50" /> Enviar por e-mail
        </b-button>
        <b-button
          variant="outline-success"
          class="mb-1"
          :disabled="aiLoading"
          @click="sendAiByChannel('whatsapp', 'whatsapp')"
        >
          <feather-icon icon="MessageCircleIcon" class="mr-50" /> Enviar por
          WhatsApp
        </b-button>

        <template
          v-if="
            canReadAiPreInterview &&
            aiStatus &&
            aiStatus.status === 'concluida'
          "
        >
          <hr />
          <b-button variant="primary" @click="goToAiResults">
            <feather-icon icon="FileTextIcon" class="mr-50" /> Ver resultados
          </b-button>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import useAppConfig from "@core/app-config/useAppConfig";
import { useToast } from "vue-toastification/composition";
import { mapActions } from "vuex";
import { BCard, BCardText, BRow, BCol, BButton, BBadge, BModal } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import * as profileTypes from "@/constants/profile";
import * as types from "../store/types";
import {
  UPDATE_ACTION,
  READ_ACTION,
  CREATE_ACTION,
  MANAGE_ACTION,
  APP_MEU_FUTURO,
  MOMENTO_X,
  AI_PRE_INTERVIEW,
  CUSTOMER_RESOURCE,
  PLAN_IMPLEMENTATION_RESOURCE,
} from "@/constants/resources";
import { createWppAiPreInterviewMessage } from "@/helpers/whatsapp_messages";

// Rótulo + variante do badge por estado da jornada da Pré-Entrevista por IA
const AI_STATUS_MAP = {
  nao_enviada: { label: "Não enviada", variant: "secondary" },
  enviada: { label: "Enviada", variant: "info" },
  acessada: { label: "Acessada", variant: "primary" },
  em_preenchimento: { label: "Em preenchimento", variant: "warning" },
  concluida: { label: "Concluída", variant: "success" },
  expirada: { label: "Expirada", variant: "dark" },
  erro: { label: "Erro", variant: "danger" },
  reaberta: { label: "Reaberta", variant: "info" },
};

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BButton,
    BBadge,
    BModal,
  },
  data() {
    return {
      loading: false,
      aiLoading: false,
      aiStatus: null,
      cashFlowFrontEndUrl: process.env.VUE_APP_CASH_FLOW_FRONTEND_URL,
      financialDiagnosisUrl:
        process.env.VUE_APP_FINANCIAL_DIAGNOSIS_FRONTEND_URL,
      plannerCodeLoading: false,
      generatedPlannerCode: null,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    customerType: String,
  },
  setup() {
    const { skin } = useAppConfig();
    return { toast: useToast(), skin };
  },
  mounted() {
    if (
      (this.canSendAiPreInterview || this.canReadAiPreInterview) &&
      this.customer?.token
    ) {
      this.refreshAiStatus();
    }
  },
  computed: {
    profileType: function () {
      return profileTypes;
    },
    hasInterview: function () {
      return this.customer?.interviews?.length;
    },
    canSendAiPreInterview: function () {
      return this.$can(CREATE_ACTION, AI_PRE_INTERVIEW);
    },
    canReadAiPreInterview: function () {
      return this.$can(READ_ACTION, AI_PRE_INTERVIEW);
    },
    aiConcluded: function () {
      return this.aiStatus && this.aiStatus.status === "concluida";
    },
    aiStatusData: function () {
      const status = this.aiStatus?.status || "nao_enviada";
      return AI_STATUS_MAP[status] || AI_STATUS_MAP.nao_enviada;
    },
    aiCardSubtitle: function () {
      if (!this.aiStatus || this.aiStatus.status === "nao_enviada") {
        return "Envie a Pré-Entrevista por IA para o seu cliente responder antes da reunião.";
      }
      if (this.aiStatus.status === "concluida") {
        return "Concluída! Acesse o resumo e as respostas do seu cliente.";
      }
      if (this.aiStatus.status === "reaberta") {
        return "Reaberta — envie a Pré-Entrevista por IA novamente.";
      }
      return "Acompanhe o andamento da Pré-Entrevista por IA do seu cliente.";
    },
    canReadApp: function () {
      return this.$can(READ_ACTION, APP_MEU_FUTURO)
    },
    canReadMomentX: function () {
      // User must have read access to MOMENTO_X.
      if (!this.$can(READ_ACTION, MOMENTO_X)) {
        return false;
      }

      // If the user has update access, they can read MOMENTO_X.
      if (this.$can(UPDATE_ACTION, MOMENTO_X)) {
        return true;
      }

      return this.customer.financial_planning_current_step > 1 &&
            this.customer.financial_planning_finished_at != null;
    },
    hasFinishedPreInterview: function () {
      return (
        this.customer?.interviews?.length > 0 &&
        this.customer.interviews[0].is_interview === true
      );
    },
    // Reabrir também quando só a Pré-Entrevista por IA foi concluída (o fluxo
    // comum exige entrevista local finalizada; a IA tem endpoint próprio).
    canReopenPreInterview: function () {
      return this.hasFinishedPreInterview || this.aiConcluded;
    },
    canUpdateCustomer: function () {
      return this.$can(UPDATE_ACTION, CUSTOMER_RESOURCE);
    },
    canManagePlanImplementation: function () {
      return this.$can(MANAGE_ACTION, PLAN_IMPLEMENTATION_RESOURCE);
    },
  },
  methods: {
    ...mapActions({
      getToken: types.GET_CUSTOMER_CASH_FLOW_TOKEN,
      getFinancialDiagnosisToken: types.GET_CUSTOMER_FINANCIAL_DIAGNOSIS_TOKEN,
      generateAiPreInterviewLink: types.GENERATE_AI_PRE_INTERVIEW_LINK,
      getAiPreInterviewStatus: types.GET_AI_PRE_INTERVIEW_STATUS,
      reopenPreInterviewAction: types.REOPEN_PRE_INTERVIEW,
      reopenAiPreInterviewAction: types.REOPEN_AI_PRE_INTERVIEW,
      generatePlannerCodeAction: types.GENERATE_PLANNER_CODE,
    }),
    refreshAiStatus() {
      this.getAiPreInterviewStatus(this.customer.token)
        .then((response) => {
          this.aiStatus = response.data;
        })
        .catch(() => {
          // silencioso: status é informativo no card
        });
    },
    onAiCardClick() {
      // Concluída: não há reenvio pelo card — vai direto aos resultados.
      // (Reenviar só após reabrir a pré-entrevista pelo card correspondente.)
      if (this.aiConcluded) {
        this.goToAiResults();
        return;
      }
      this.openAiPreInterviewModal();
    },
    openAiPreInterviewModal() {
      this.$bvModal.show("ai-pre-interview-modal");
    },
    sendAiByChannel(channel, action) {
      this.aiLoading = true;
      this.generateAiPreInterviewLink({
        customer_token: this.customer.token,
        channel,
      })
        .then((response) => {
          const url = response.data?.url;
          if (action === "open") {
            window.open(url, "_blank");
          } else if (action === "copy") {
            navigator.clipboard.writeText(url);
            this.notify(
              "Link copiado!",
              "O link da Pré-Entrevista por IA foi copiado para a área de transferência.",
              "success"
            );
          } else if (action === "email") {
            this.notify(
              "E-mail enviado!",
              "A Pré-Entrevista por IA foi enviada por e-mail para o cliente.",
              "success"
            );
          } else if (action === "whatsapp") {
            const message = createWppAiPreInterviewMessage(
              this.customer.name,
              url
            );
            window.open(
              "https://api.whatsapp.com/send?phone=" +
                (this.customer.cell_phone || "") +
                "&text=" +
                message,
              "_blank"
            );
          }
          this.refreshAiStatus();
          this.$bvModal.hide("ai-pre-interview-modal");
        })
        .catch((err) => {
          // 422 traz orientação específica (ex.: cliente sem e-mail cadastrado)
          const backendMessage = err?.response?.data?.message;
          this.notify(
            "Oops!",
            backendMessage ||
              "Não foi possível gerar a Pré-Entrevista por IA. Tente novamente ou contate o setor de TI.",
            "danger"
          );
        })
        .finally(() => {
          this.aiLoading = false;
        });
    },
    goToAiResults() {
      this.$bvModal.hide("ai-pre-interview-modal");
      this.$router.push({
        name: "ai-pre-interview-results",
        params: { id: this.customer?.id },
      });
    },
    notify(title, text, variant) {
      this.toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: variant === "danger" ? "AlertTriangleIcon" : "CheckCircleIcon",
          variant,
        },
      });
    },
    getCustomerCashFlowToken() {
      this.loading = true;
      this.getToken(this.$route.params.id)
        .then((response) => {
          setTimeout(() => {
            window
              .open(
                this.cashFlowFrontEndUrl +
                  "/autenticacao/" +
                  response.data?.token,
                "_blank"
              )
              .focus();
          });
        })
        .catch((error) => {
          let title = "Oops!";
          let text =
            "Ocorreu um erro ao acessar o fluxo de caixa do cliente. Entre em contato com o setor de TI.";
          let variant = "danger";
          if (error.response.status === 404) {
            title = "Cliente sem acesso ao Meu Futuro App";
            text =
              "Este cliente não criou conta no Meu Futuro App. Verifique nossos links úteis e solicite que o cliente crie uma conta";
            variant = "warning";
          }
          this.toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon: "AlertTriangleIcon",
              variant,
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomerFinancialDiagnosisToken() {
      this.loading = true;
      this.getFinancialDiagnosisToken({
        customer_token: this.customer.token,
        days: 7,
      })
        .then((response) => {
          setTimeout(() => {
            const link =
              this.financialDiagnosisUrl +
              "/autenticacao/" +
              response.data?.authentication_token +
              "?back-url=diagnosis/" +
              this.customer.token;
            setTimeout(() => {
              window.open(link, "_blank");
            });
          });
        })
        .catch((error) => {
          let title = "Oops!";
          let text =
            "Ocorreu um erro ao acessar o fluxo de caixa do cliente. Entre em contato com o setor de TI.";
          let variant = "danger";
          this.toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon: "AlertTriangleIcon",
              variant,
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goToFinancialPlanning() {
      this.$router.push({
        name: "financial-planning",
        params: { id: this.customer?.id },
      });
    },

    goToPlanImplementation() {
      this.$router.push({
        name: "plan-implementation",
        params: { id: this.customer?.id },
      });
    },

    openPlannerCodeModal() {
      this.generatedPlannerCode = null;
      this.$bvModal.show("planner-code-modal");
    },
    handleGeneratePlannerCode() {
      this.plannerCodeLoading = true;
      this.generatePlannerCodeAction({
        lead_name: this.customer.name,
        lead_email: this.customer.email || null,
        customer_id: this.customer.id,
      })
        .then((response) => {
          this.generatedPlannerCode = response.data?.data?.code;
        })
        .catch(() => {
          this.notify(
            "Oops!",
            "Não foi possível gerar o código de acesso. Tente novamente ou contate o setor de TI.",
            "danger"
          );
        })
        .finally(() => {
          this.plannerCodeLoading = false;
        });
    },
    copyPlannerCode() {
      navigator.clipboard.writeText(this.generatedPlannerCode).then(() => {
        this.notify("Código copiado!", "O código foi copiado para a área de transferência.", "success");
      });
    },
    sharePlannerCodeWhatsApp() {
      const name = this.customer.name?.split(" ")[0] || "Cliente";
      const phone = (this.customer.cell_phone || "").replace(/\D/g, "");
      const message = encodeURIComponent(
        `Olá, ${name}! Seu código de acesso ao *Meu Futuro App* é:\n\n*${this.generatedPlannerCode}*\n\nBaixe o app e insira esse código ao criar sua conta para ficar conectado à nossa consultoria. 🚀`
      );
      window.open(`https://api.whatsapp.com/send?phone=55${phone}&text=${message}`, "_blank");
    },
    async reopenPreInterview() {
      // Cliente só com a Pré-Entrevista por IA: reabertura própria (o endpoint
      // comum exige entrevista local finalizada e retornaria 400).
      const aiOnly = !this.hasFinishedPreInterview && this.aiConcluded;

      const confirmed = await this.$bvModal.msgBoxConfirm(
        aiOnly
          ? "Isso vai reabrir a Pré-Entrevista por IA para que o cliente possa preenchê-la novamente. Os resultados já recebidos são preservados. Deseja continuar?"
          : "Isso vai reabrir a pré-entrevista para que o cliente possa preenchê-la novamente. Os dados já informados são preservados. Deseja continuar?",
        {
          title: aiOnly ? "Reabrir Pré-Entrevista por IA" : "Reabrir pré-entrevista",
          okTitle: "Reabrir",
          cancelTitle: "Cancelar",
          okVariant: "warning",
          centered: true,
        }
      );
      if (!confirmed) return;

      if (aiOnly) {
        this.loading = true;
        this.reopenAiPreInterviewAction(this.customer.token)
          .then(() => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Pré-Entrevista por IA reaberta!",
                text: "O reenvio está liberado — use o card Pré-Entrevista por IA para enviar o novo acesso.",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            this.refreshAiStatus();
          })
          .catch((error) => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text:
                  error?.response?.data?.message ||
                  "Não foi possível reabrir a Pré-Entrevista por IA.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.loading = false;
          });
        return;
      }

      this.loading = true;
      this.reopenPreInterviewAction(this.customer.token)
        .then((response) => {
          const authToken = response.data?.authentication_token;
          const link = authToken
            ? `${process.env.VUE_APP_FRONT_END_URL}/autenticacao_cliente/${authToken}?back_url=pre_entrevista/${this.customer.token}`
            : null;

          if (link && navigator.clipboard) {
            navigator.clipboard.writeText(link).catch(() => {});
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: "Pré-entrevista reaberta!",
              text: link
                ? "O link de preenchimento foi copiado para a área de transferência. Envie-o ao cliente."
                : "O cliente já pode preencher a pré-entrevista novamente.",
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          // Reabrir libera o reenvio da Pré-Entrevista por IA (concluida→reaberta).
          this.refreshAiStatus();
        })
        .catch((error) => {
          const text =
            error?.response?.data?.message ||
            "Não foi possível reabrir a pré-entrevista. Entre em contato com o setor de TI.";
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.clickable {
  cursor: pointer;
}

// Altura uniforme dos cards do grid: o badge de status da IA adiciona uma linha
// extra e deixava o card mais alto que os vizinhos. Todos esticam até a coluna
// e a linha divisória (última) fica presa na base.
.tool-card {
  height: 100%;
}
::v-deep .tool-card .card-body {
  display: flex;
  flex-direction: column;
}
::v-deep .tool-card .card-body > .row:last-child {
  margin-top: auto !important;
}

.disabled-card {
  cursor: not-allowed;
  opacity: 0.6;
}

.rounded-icon {
  border: var(--info) 2px solid;
  border-radius: 50%;
  padding: 15px;
}

.planner-code-display {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  border: 2px dashed var(--info);
  border-radius: 8px;
  padding: 16px;
}

.planner-code-value {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.4em;
  color: var(--info);
  font-family: monospace;
}
</style>
